import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { SubmitToolModal } from './SubmitToolModal';
export function SubmitToolButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <motion.button onClick={() => setIsModalOpen(true)} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 text-white hover:bg-white/20 transition-all text-sm font-medium" data-id="element-132">
        <Plus size={16} data-id="element-133" />
        <span data-id="element-134">Submit Tool</span>
      </motion.button>

      <SubmitToolModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-135" />
    </>;
}